export const CELL_STYLES = {
  'white-space': 'normal',
  'word-break': 'break-word',
  'overflow-wrap': 'break-word',
  'line-height': '1.5em',
  'padding': '8px 10px',
};
